import React from "react";
import { AiOutlineArrowRight } from "react-icons/ai";

const Blogs = () => {
  const blogs = [
    {
      title: "Finding Balance in Ambition",
      url: "https://medium.com/@emilyhan0212/finding-balance-in-ambition-82071f6b7481",
      desc: "It was midnight, and I was sitting at my desk, a half-finished coding project open on one screen, fina....",
    },
    {
      title: "Why Knowing Less Might Be the Future",
      url: "https://medium.com/@emilyhan0212/why-knowing-less-might-be-the-future-007a8fddd351",
      desc: "Today I want to talk about something I’ve been thinking about for a while, Ever since ChatGPT and other AI to....",
    },
    {
      title: "How I Found My Why",
      url: "https://medium.com/@emilyhan0212/how-i-found-my-why-45297ec7152a",
      desc: "When I started college, everyone around me had one goal: get a job. It didn’t even matter what kind. J....",
    },
    {
      title: "As a College Student: How I’m learning to handle Rejections",
      url: "https://medium.com/@emilyhan0212/as-a-college-student-how-im-learning-to-handle-rejections-51c2e0a2f61f",
      desc: "Rejection happens all the time. Sometimes it’s small, like when you ask for a favor and get a no, or whe...",
    },
  ];

  return (
    <div id="blog" className="portfolio">
      <h1 className="mainHeading">My Blogs</h1>
      <p className="mainPara">Thoughts & Experiences</p>
      <div className="projects">
        {blogs.map((blog, index) => (
          <div className="project" key={index}>
            <h4 className="projectTitle">{blog.title}</h4>
            <p className="projectDesc">{blog.desc}</p>
            <a
              className="projectLink"
              href={blog.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Read <AiOutlineArrowRight className="proIcon" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
